module.exports = __webpack_public_path__ + "media/zoiler.c632e545.mp4";